//  用户相关的所有请求
import { request } from '@/utils/request'
//  登录
export function loginAPI(formData) {
  return request({
    url: '/oauth/WeiXinCallback',
    method: 'GET',
    params: formData
  })
}
//  手机号登录
export function loginPhoneAPI(data) {
  return request({
    url: '/Oauth/MobileLogin',
    method: 'POST',
    data
  })
}
//  绑定手机号
export function bindPhoneAPI(data) {
  return request({
    url: '/Oauth/BindMobile',
    method: 'POST',
    data
  })
}
//  修改密码
export function editAccountPasswordAPI(data) {
  return request({
    url: '/Oauth/UpdatePassword',
    method: 'POST',
    data
  })
}
//  获取账号信息
export function getAccountInfoAPI(data) {
  return request({
    url: '/data/GetBizUserInfo',
    method: 'POST',
    data
  })
}
//  获取用户菜单列表
export function getUserMenuListAPI(data) {
  return request({
    url: '/data/GetBizMenuList',
    method: 'POST',
    data
  })
}
//  关注楼盘
export function followHouse(data) {
  return request({
    url: '/data/UserFollowLouPan',
    method: 'POST',
    data
  })
}
//  获取账号资金明细列表
export function getAccountBalanceListAPI(data) {
  return request({
    url: '/data/GetBizAccountChangeLog',
    method: 'POST',
    data
  })
}
//  线索楼盘列表
export function getClueHouseListAPI(data) {
  return request({
    url: '/data/GetLouPanClueStatistic',
    method: 'POST',
    data
  })
}
//  线索楼盘访客列表
export function getClueHouseUserListAPI(data) {
  return request({
    url: '/data/GetLouPanViewerList',
    method: 'POST',
    data
  })
}
//  线索楼盘访客列表--新
export function getClueHouseUserList2API(data) {
  return request({
    url: '/data/GetLouPanViewerList2',
    method: 'POST',
    data
  })
}
//  用户信息
export function getUserDetailAPI(data) {
  return request({
    url: '/data/GetUserProfile',
    method: 'POST',
    data
  })
}
//  用户搜索记录
export function getUserSearchListAPI(data) {
  return request({
    url: '/data/GetUserSearchLog',
    method: 'POST',
    data
  })
}
//  用户位置授权记录
export function getUserAddressListAPI(data) {
  return request({
    url: '/data/GetUserAddressList',
    method: 'POST',
    data
  })
}
//  用户访问楼盘记录
export function getUserHouseViewListAPI(data) {
  return request({
    url: '/data/GetLouPanViewLogs',
    method: 'POST',
    data
  })
}
//  用户房源偏好列表
export function getUserRoomViewListAPI(data) {
  return request({
    url: '/data/GetHouseViewLogs',
    method: 'POST',
    data
  })
}
//  用户户型偏好列表
export function getUserRoomTypeViewListAPI(data) {
  return request({
    url: '/data/GetRoomTypeViewLogs',
    method: 'POST',
    data
  })
}
//  用户意向楼盘列表
export function getUserIntentionHouseListAPI(data) {
  return request({
    url: '/data/GetUserIntentLouPanList',
    method: 'POST',
    data
  })
}
//  加客资
export function addCustomerAPI(data) {
  return request({
    url: '/data/AddCustomer',
    method: 'POST',
    data
  })
}
//  批量添加客资
export function addAllCustomerAPI(data) {
  return request({
    url: '/data/BatchAddCustomer',
    method: 'POST',
    data
  })
}
//  预选
export function addPreSelectionAPI(data) {
  return request({
    url: '/data/UpdateTemplateCustomer',
    method: 'POST',
    data
  })
}
//  预选列表
export function getPreSelectionListAPI(data) {
  return request({
    url: '/data/GetTemplateCustomers',
    method: 'POST',
    data
  })
}
//  我的客资列表
export function getMyCustomerListAPI(data) {
  return request({
    url: '/data/GetMyDistributeCustomer',
    method: 'POST',
    data
  })
}
//  我的客资统计
export function getMyCustomerCountAPI(data) {
  return request({
    url: '/data/GetMyCustomerStatistic',
    method: 'POST',
    data
  })
}
//  分客
export function allocationCustomerAPI(data) {
  return request({
    url: '/data/DistributeCustomer',
    method: 'POST',
    data
  })
}
//  全部标签列表
export function getLabelListAPI(data) {
  return request({
    url: '/data/GetLabelList',
    method: 'POST',
    data
  })
}
//  跟进人列表（带分页）
export function getFollowUpUserListAPI(data) {
  return request({
    url: '/data/GetMyFollowUpUsers',
    method: 'POST',
    data
  })
}
//  全部跟进人列表
export function getAllFollowUpUserListAPI(data) {
  return request({
    url: '/data/GetAllFollowUpUsers',
    method: 'POST',
    data
  })
}
//  设置跟进人允许未标记客资数量
export function updateFollowUpUserNoLableNumAPI(data) {
  return request({
    url: '/data/UpdateFollowUpUserNoLableNum',
    method: 'POST',
    data
  })
}
//  下架跟进人
export function deleteFollowUpUserAPI(data) {
  return request({
    url: '/data/RemoveBoss',
    method: 'POST',
    data
  })
}
//  用户动态列表
export function getDynamicListAPI(data) {
  return request({
    url: '/data/GetCustomerOperatorLogs',
    method: 'POST',
    data
  })
}
//  用户动态列表
export function getAllocationLogListAPI(data) {
  return request({
    url: '/data/GetDistributeCustomerLogs',
    method: 'POST',
    data
  })
}
//  客资匹配列表
export function getMatchCustomerListAPI(data) {
  return request({
    url: '/data/MatchCustomer',
    method: 'POST',
    data
  })
}
//  客资匹配导入
export function uploadMatchMobileFileAPI(data) {
  let params = new FormData()
  params.append('file', data.file)
  return request({
    url: '/data/UploadMobileData',
    method: 'POST',
    data: params
  })
}
//  客资匹配提交
export function addMatchMobileAPI(data) {
  return request({
    url: '/data/MatchCustomerFromMobile',
    method: 'POST',
    data
  })
}
//  添加标记
export function addUserLabelAPI(data) {
  return request({
    url: '/data/SetLabel',
    method: 'POST',
    data
  })
}

//  楼盘访客二维码列表
export function getHouseVisitorQRcodeAPI(data) {
  return request({
    url: '/data/GetLouPanVisitRecordQRCode',
    method: 'POST',
    data
  })
}
//  楼盘访客二维码配置
export function configHouseVisitorQRcodeAPI(data) {
  return request({
    url: '/data/UpdateQRCodeSetting',
    method: 'POST',
    data
  })
}
//  楼盘访客列表
export function getHouseVisitorListAPI(data) {
  return request({
    url: '/data/GetLouPanVisitRecordList',
    method: 'POST',
    data
  })
}
//  楼盘访客新增
export function addHouseVisitorAPI(data) {
  return request({
    url: '/data/AddLouPanVisitor',
    method: 'POST',
    data
  })
}
//  楼盘访客编辑
export function updateHouseVisitorAPI(data) {
  return request({
    url: '/data/UpdateLouPanVisitor',
    method: 'POST',
    data
  })
}